import styled from 'styled-components';

export const Container = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing.xl};
  background-color: ${({ theme }) => theme.colors.surface};
`;

export const Card = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 1.6rem;
  padding: ${({ theme }) => theme.spacing.xxl};
  max-width: 42rem;
  width: 100%;
  text-align: center;
`;

export const Icon = styled.div`
  font-size: 5.6rem;
  margin-bottom: ${({ theme }) => theme.spacing.lg};
`;

export const Title = styled.div`
  font-size: 2.2rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.darkSlate};
  margin-bottom: ${({ theme }) => theme.spacing.sm};
`;

export const Subtitle = styled.div`
  font-size: 1.5rem;
  color: ${({ theme }) => theme.colors.slateGrey};
  line-height: 1.6;
  margin-bottom: ${({ theme }) => theme.spacing.xl};
`;

export const Divider = styled.div`
  height: 0.1rem;
  background-color: ${({ theme }) => theme.colors.border};
  margin: ${({ theme }) => `${theme.spacing.lg} 0`};
`;

export const Hint = styled.div`
  font-size: 1.3rem;
  color: ${({ theme }) => theme.colors.slateGrey};
  line-height: 1.5;
`;

export const Logo = styled.div`
  font-size: 1.8rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.accent};
  margin-bottom: ${({ theme }) => theme.spacing.xl};
`;
